module.exports = __webpack_public_path__ + "media/images/odber-6720089168e9a9fe5e16f4e7e0ec2cf5.png";